import { GetLinkFromLinkAttribute } from "vagaro-website-rendering/src/components/ComponentRenders/RenderButton";
import { AttributeCollection, getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { PageData } from "../Data/SiteData";
import { GetLinkAndType, LinkTypes } from "vagaro-website-rendering/src/components/Definitions/LinkData";

export default function AnnouncementBanner({atts,onSelect,inId,pageData,isEditor}:{atts:AttributeCollection,onSelect?:Function,inId:string,pageData:PageData[],isEditor?:boolean}){


    const show = getNodeComponentAttributeValue(atts,"announcementToggle","")=="true";


    const bg = getNodeComponentAttributeValue(atts,"annoucementBg","var(--theme-color-2)");
    const txtClr = getNodeComponentAttributeValue(atts,"annoucementTxtClr","var(--theme-color-5)");
    const link = getNodeComponentAttributeValue(atts,"annoucementlink","");
    const content = getNodeComponentAttributeValue(atts,"announcementText","Type Message");

    let expiresAt = getNodeComponentAttributeValue(atts,"announcementExpiresAt","");


    let linkURL = GetLinkFromLinkAttribute(link,pageData);
    let lData  = GetLinkAndType(link);
    let isPromo = (lData.type === LinkTypes.PromoCode);

    if(lData.type != LinkTypes.DailyDeal&&lData.type != LinkTypes.PromoCode){
        expiresAt = "";
    }

    if(!show)
        return null;

    let pType = getNodeComponentAttributeValue(atts,"textStyle","vp-1");

   return <><div className="w-full relative center-all"><a style={{background:bg,padding:"10px 34px",pointerEvents:(isPromo&&!isEditor?"none":"all"),cursor:(isPromo)?"default":"pointer"}} 
   href={linkURL}
   onClick={(e:any)=>{



        if(onSelect){
            e.preventDefault();
            onSelect()
        }

    }}
   
   id="announcement-banner" 
    target={lData.type === LinkTypes.Url||lData.type===LinkTypes.DailyDeal||LinkTypes.Form?"_blank":""}
    rel='noreferrer'
   {...{"data-expires-at":expiresAt}}
   className={"announcement w-full no-a " }>

   <span className={pType} style={{color:txtClr,textAlign:"center"}} dangerouslySetInnerHTML={{__html:content}}>
 

   </span>
   {isPromo&&<strong className={pType} style={{color:txtClr,fontWeight:"bold"}}>&nbsp;{lData.link}</strong>}
   </a> <button className="invisible-button announcement-dismiss-button " id={inId} style={{color:txtClr,pointerEvents:"all",position:"absolute",right:"8px",width:"28px",top:"calc(50% - 21px)",fontSize:"26px",fontFamily:"monospace",background:"none"}}  >&times;</button></div>

   </>



}